import { render, staticRenderFns } from "./RelatoriosSeguro.vue?vue&type=template&id=92cc836a&scoped=true"
import script from "./RelatoriosSeguro.vue?vue&type=script&lang=js"
export * from "./RelatoriosSeguro.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosSeguro.vue?vue&type=style&index=0&id=92cc836a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cc836a",
  null
  
)

export default component.exports